import type { SentrySDK, SentrySurface } from './types';

interface MissingTranslationDetails {
  id: string;
  locale: string;
}

export function createMissingTranslationSentryReporter(
  sentry: Pick<SentrySDK, 'captureMessage' | 'withScope'>,
  surface: SentrySurface,
): (details: MissingTranslationDetails) => void {
  return ({ id, locale }) => {
    sentry.withScope((scope) => {
      scope.setLevel('warning');
      scope.setTag('surface', surface);
      scope.setTag('module', 'localization');
      scope.setTag('locale', locale);
      scope.setContext('translation', {
        id,
        locale,
      });
      sentry.captureMessage(`Missing translation key: ${id}`, 'warning');
    });
  };
}
